import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "join w-min" }
const _hoisted_2 = { class: "join w-min" }

import { HoldTapConfig } from "@/keyboard";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import IntegerInput from "@/components/utils/IntegerInput.vue";
import ListSelect from "@/components/utils/ListSelect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HoldTapOptions',
  props: {
    timeout: {},
    tap_hold_interval: {},
    config: {}
  },
  emits: ["update:timeout", "update:tap_hold_interval", "update:config"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SettingsOption, {
      label: "Timeout",
      tooltip: "Time in milliseconds that determines whether the 'hold' or 'tap' action will be used"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(IntegerInput, {
            class: "w-[9ch] input-sm join-item",
            min: 0,
            max: 65535,
            modelValue: _ctx.timeout,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:timeout', $event)))
          }, null, 8, ["modelValue"]),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "join-item btn-input-unit btn-input-unit-sm" }, "ms", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(SettingsOption, {
      label: "Config",
      tooltip: "Additional configuration for resolving between 'hold' and 'tap'"
    }, {
      default: _withCtx(() => [
        _createVNode(ListSelect, {
          class: "w-[26ch]",
          clearable: false,
          options: ['Default', 'HoldOnOtherKeyPress', 'PermissiveHold'],
          modelValue: _ctx.config,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:config', $event)))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(SettingsOption, {
      label: "Tap-hold interval",
      tooltip: 
      'Two successive key presses in less then this interval will result in the \'tap\' action' +
      ' being used (instead of \'hold\') when holding this key. Inverval of 0 disables this feature.'
    
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(IntegerInput, {
            class: "w-[9ch] input-sm join-item",
            min: 0,
            max: 65535,
            modelValue: _ctx.tap_hold_interval,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:tap_hold_interval', $event)))
          }, null, 8, ["modelValue"]),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "join-item btn-input-unit btn-input-unit-sm" }, "ms", -1))
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})